import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Start with 23:59:37 as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex justify-center items-center gap-4 text-3xl md:text-5xl font-bold font-sans text-wine-700 my-6" data-id="element-313">
      <div className="flex flex-col items-center" data-id="element-314">
        <span className="bg-white px-4 py-2 rounded-xl shadow-sm border border-wine-100" data-id="element-315">
          {format(timeLeft.hours)}
        </span>
        <span className="text-xs text-gray-500 mt-2 uppercase tracking-wider" data-id="element-316">
          HS
        </span>
      </div>
      <span className="text-wine-300 -mt-6" data-id="element-317">:</span>
      <div className="flex flex-col items-center" data-id="element-318">
        <span className="bg-white px-4 py-2 rounded-xl shadow-sm border border-wine-100" data-id="element-319">
          {format(timeLeft.minutes)}
        </span>
        <span className="text-xs text-gray-500 mt-2 uppercase tracking-wider" data-id="element-320">
          MIN
        </span>
      </div>
      <span className="text-wine-300 -mt-6" data-id="element-321">:</span>
      <div className="flex flex-col items-center" data-id="element-322">
        <span className="bg-white px-4 py-2 rounded-xl shadow-sm border border-wine-100" data-id="element-323">
          {format(timeLeft.seconds)}
        </span>
        <span className="text-xs text-gray-500 mt-2 uppercase tracking-wider" data-id="element-324">
          SEG
        </span>
      </div>
    </div>;
}